import { AnyEventObject, DoneActorEvent } from 'xstate';
import { emptyEmploymentForm } from './constants';
import { DeleteEmploymentEvent, EditEmploymentEvent, SortEmploymentEvent } from './events';
import { EmploymentFormValues, Scope } from './types';

export const toggleLoading = {
  loading: ({ context }: Scope) => !context.loading,
};

export const openModal = {
  modal: () => ({
    create: true,
    edit: false,
  }),
  employmentForm: () => emptyEmploymentForm,
};

export const closeModal = {
  modal: () => ({
    create: false,
    edit: false,
  }),
};

export const setEmploymentSort = {
  sort: ({ context, event }: Scope) => {
    const _event = event as SortEmploymentEvent;
    return {
      ...context.sort,
      sortBy: _event.sortBy,
      [_event.sortBy]: -1 * context.sort[_event.sortBy],
    };
  },
};

export const updateEmploymentFromPatch = {
  employments: ({ context, event }: Scope) => {
    const { output } = event as unknown as DoneActorEvent<EmploymentFormValues>;
    const updatedEmployment = output;
    const untouchedEmployments = context.employments.filter(
      (employment) => employment.id != updatedEmployment.id
    );
    untouchedEmployments.push(updatedEmployment);
    return untouchedEmployments;
  },
};

export const updateEmploymentFromCreate = {
  employments: ({ context, event }: Scope) => {
    const { output } = event as unknown as DoneActorEvent<EmploymentFormValues>;
    return [...context.employments, output];
  },
};

export const resetEmploymentState = {
  loading: false,
  employmentForm: emptyEmploymentForm,
  modal: {
    create: false,
    edit: false,
  },
};

export const resetLoading = {
  loading: false,
};

export const updateFacilityForm = {
  employmentForm: ({ context, event }: Scope) => {
    const { facility } = event as AnyEventObject;
    return {
      ...context.employmentForm,
      facility: facility,
    };
  },
};

export const deleteEmploymentFromContext = {
  employments: ({ context }: Scope) => {
    return context.employments.filter((employment) => {
      return employment.id !== context.idToDelete;
    });
  },
};

export const setEmploymentIdToDelete = {
  idToDelete: ({ event }: Scope) => (event as DeleteEmploymentEvent).payload.id,
};

export const editEmployment = {
  employmentForm: ({ context, event }: Scope) => {
    const { payload } = event as EditEmploymentEvent;
    return (
      context.employments.find((employment) => employment.id == payload.id) || emptyEmploymentForm
    );
  },
  modal: ({ context }: Scope) => ({
    ...context.modal,
    edit: true,
    create: false,
  }),
};
